// extracted by mini-css-extract-plugin
export var header = "SectionHeader-module--header--21bfv";
export var header__title = "SectionHeader-module--header__title--1g6Ay";
export var header__description = "SectionHeader-module--header__description--3VrRF";